import { Dropdown } from '../../../../components/dropdown/dropdown';
import { Button } from '../../../../components/form/button';
import { Typography } from '../../../../components/typography/typography';
import Icon from '../../../../components/icons/icon';
import React, { useState } from 'react';
import { Order } from '../../../../clients/quipli-service/order/order';
import { useAdmin } from '../../../../hooks/use-admin-context';
import { PdfPrinter } from '../../../../components/pdf-printer/pdf-printer';

export const PrintMenu = ({ order }: { order: Order }) => {
  const { contextPath } = useAdmin();
  const [pdfToPrint, setPdfToPrint] = useState<string | undefined>();

  return (
    <>
      <Dropdown
        placement="bottom-end"
        dataCy="print-menu"
        trigger={() => (
          <Button className="button button-secondary" data-cy={`download_menu`}>
            <Typography type="text-sm" weight="semi-bold" className="text-[var(--grey-700)] hidden md:inline">
              Print
            </Typography>

            <div className="inline md:hidden">
              <Icon icon="Download" />
            </div>

            <Icon icon="ChevronDown" />
          </Button>
        )}
      >
        {!order.isCycleBilled && order.invoices.length == 0 && (
          <div
            className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
            onClick={() => {
              setPdfToPrint(`${contextPath}legacy-app/manager/orders/invoice?orders=${order.id}`);
            }}
          >
            <Typography
              className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
              type="text-sm"
            >
              Invoice
            </Typography>
          </div>
        )}

        <div
          className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
          onClick={() => {
            setPdfToPrint(`${contextPath}legacy-app/manager/orders/contract_rental_policy/${order.id}/unsigned`);
          }}
        >
          <Typography
            className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
            type="text-sm"
          >
            Sign in person
          </Typography>
        </div>
        <div
          className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
          onClick={() => {
            setPdfToPrint(`${contextPath}quipli-service/yorent/v2/orders/${order.id}/contract`);
          }}
        >
          <Typography
            className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
            type="text-sm"
          >
            Contract
          </Typography>
        </div>

        {order.signature && (
          <div
            className="min-w-full flex justify-start items-center gap-2 px-0 hover:bg-[var(--grey-100)]"
            onClick={() => {
              setPdfToPrint(`${contextPath}legacy-app/manager/orders/contract_rental_policy/${order.id}/signed`);
            }}
          >
            <Typography
              className="flex justify-center justify-items-center gap-1 text-[var(--quipli-black-800)]"
              type="text-sm"
            >
              Signed Contract
            </Typography>
          </div>
        )}
      </Dropdown>

      <PdfPrinter pdf={pdfToPrint} onComplete={() => setPdfToPrint(undefined)} />
    </>
  );
};
